import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { API_ENDPOINTS } from "../constants/api";
import "./HomePage.css";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await api.post(API_ENDPOINTS.AUTH.REGISTER, {
        email: formData.email,
        password: formData.password,
        role: 1,
      });

      if (!response.ok) {
        const apiMessage =
          response?.data?.message || "Could not create your account.";
        setError(apiMessage);
        return;
      }

      navigate("/", {
        replace: true,
        state: {
          registrationSuccess: true,
          message: "Account created successfully. Please sign in.",
        },
      });
    } catch (requestError) {
      setError(requestError.message || "Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="home-page">
      <div className="split-container">
        <div className="left-section">
          <div className="login-container">
            <div className="login-header">
              <h1>Create Account</h1>
              <p>Register for a new account</p>
            </div>

            <form
              className="login-form"
              onSubmit={handleSubmit}
            >
              {error && <div className="error-message">{error}</div>}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  disabled={isLoading}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Create your password"
                  disabled={isLoading}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  placeholder="Confirm your password"
                  disabled={isLoading}
                  required
                />
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="button-content">
                    <span className="spinner-small"></span>
                    Creating Account...
                  </span>
                ) : (
                  "Create Account"
                )}
              </button>

              <div className="signup-link">
                <p>
                  Already have an account? <Link to="/">Sign in</Link>
                </p>
              </div>
            </form>
          </div>
        </div>

        <div className="vertical-divider"></div>

        <div className="right-section">
          <div className="image-container">
            <div className="law-themed-content">
              <img
                src="/big.png"
                alt="LineaBlu Logo"
                className="hero-logo"
              />
              <h2>Center of Excellence</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;